// extracted by mini-css-extract-plugin
export var container = "_gd-1";
export var cornerButtonContainer = "_gd-6";
export var disabled = "_gd-2";
export var dragActive = "_gd-3";
export var fileContainer = "_gd-5";
export var hiddenInput = "_gd-4";
export var widthContainer = "_gd-0";